/* eslint-disable no-restricted-imports */

import loader from '@rhg/utils/images/imageLoader';
import NextImage from 'next/image';
import { ComponentProps } from 'react';

export * from 'next/image';

const Image = (props: ComponentProps<typeof NextImage>) => {
    return <NextImage {...props} loader={loader} />;
};

export default Image;
